define('controllers/multi-account',['require','chaplin','controllers/base/controller','lib/utils','helpers/application','underscore','models/base/collection','models/base/model','models/base/modal','models/pages/multi-account/page','models/pages/multi-account/params','models/pages/multi-account/accounts','models/pages/multi-account/summary','models/pages/multi-account/table','models/pages/multi-account/commission','views/pages/multi-account/page','views/pages/multi-account/navbar','views/pages/multi-account/tabs','views/pages/multi-account/summary','views/pages/multi-account/table','views/base/modal','views/pages/multi-account/transfer-content'],function(require) {
    'use strict';

    var Chaplin = require('chaplin'),
        BaseController = require('controllers/base/controller'),

        utils = require('lib/utils'),
        helpers = require('helpers/application'),

        _ = require('underscore'),

        Collection = require('models/base/collection'),
        Model = require('models/base/model'),
        ModalModel = require('models/base/modal'),

        Page = require('models/pages/multi-account/page'),
        Params = require('models/pages/multi-account/params'),
        Accounts = require('models/pages/multi-account/accounts'),
        Summary = require('models/pages/multi-account/summary'),
        Table = require('models/pages/multi-account/table'),
        Commision = require('models/pages/multi-account/commission'),

        PageView = require('views/pages/multi-account/page'),
        NavbarView = require('views/pages/multi-account/navbar'),
        TabsView = require('views/pages/multi-account/tabs'),
        SummaryView = require('views/pages/multi-account/summary'),
        TableView = require('views/pages/multi-account/table'),

        ModalView = require('views/base/modal'),
        TransferContentView = require('views/pages/multi-account/transfer-content');


    function openTransferModal(page) {
        var ContractorTypes = Collection.extend({
            urlPath: '/api/multi-account/contractor-types'
        });

        var Contractors = Collection.extend({
            urlPath: '/api/multi-account/contractors'
        });

        var Content = Model.extend({
            urlPath: '/api/multi-account/last-document-number'
        });

        var buttons = {
            start   : { caption: 'Перевести',   className: 'btn-success', 'action': 'start' },
            confirm : { caption: 'Подтвердить', className: 'btn-success', 'action': 'confirm' },
            close   : { caption: 'Закрыть',     className: '',            'action': 'cancel' }
        };

        var modalModel = new ModalModel({
            title: 'Перевод стредств',
            buttons: [
                buttons.start,
                buttons.close
            ]
        });

        var commission = new Commision({ type: 'transfer' });
        var contractorTypes = new ContractorTypes();
        var contractors = new Contractors();

        var contentModel = new Content({
            docDate: new Date(),
            lastDocumentNumber: '',
            value: 0,
            commissionValue: 0,
            currencyCode: '',

            activeCommission: null,
            selectedAccount: null,

            contractorTypeId: null,
            contractorId: null,

            stage: 'start',

            page: page,
            commission: commission,
            contractorTypes: [],
            contractors: [],
            contractorIds: []
        });

        function calcCommission() {
            var value = contentModel.get('value');
            var commission = contentModel.get('activeCommission');

            if (commission) {
                return (commission.type === 'percent' ? commission.value * value / 100 : commission.value);
            } else {
                return 0;
            }

        }

        contentModel.on('change:activeCommission', function() {
            contentModel.set('commissionValue', calcCommission());
        });

        contentModel.on('change:value', function() {
            contentModel.set('commissionValue', calcCommission());
        });

        contentModel.on('change:selectedAccount', function() {
            var account = contentModel.get('selectedAccount');

            contentModel.set({
                currencyCode: account && account.currencyCode || '',
                activeCommission: _.findWhere(commission.get('items') || [], { currencyId: account.currencyId })
            });
        });

        contentModel.on('change:contractorTypeId', function() {
            var contractorTypeId = parseInt(contentModel.get('contractorTypeId'), 10);

            var filteredContractors = new Contractors(contractors.filter(function(contractor) {
                return contractor.get('contractorTypeId') === contractorTypeId;
            }));

            var filteredContractorIds = new Contractors(contractors.filter(function(contractor) {
                return contractor.get('contractorTypeId') === contractorTypeId;
            }).sort(function(a, b) {
                return a.get('id') > b.get('id') ? 1 : (a.get('id') < b.get('id') ? -1 : 0);
            }));

            contentModel.set({
                contractors: filteredContractors.toJSON(),
                contractorIds: filteredContractorIds.toJSON(),
                contractorId: null
            });
        });



        var modalView = new ModalView({ model: modalModel });
        var contentView = new TransferContentView({ model: contentModel });

        modalView.$el.addClass('multi-account-transfer');

        modalView.subview('content', contentView);

        modalModel.trigger('showPreloader');
        contentModel.fetch().then(function() {
            commission.fetch().then(function() {

                contractors.fetch().then(function() {
                    contentModel.set({
                        contractors: [],
                        contractorIds: []
                    });

                    contractorTypes.fetch().then(function() {
                        contentModel.set({
                            contractorTypes: contractorTypes.toJSON(),
                            contractorTypeId: null,
                            contractorId: null
                        });

                        modalModel.trigger('hidePreloader');

                        //contentView.render();

                        var account = _.findWhere(page.get('accounts').get('items'), { currencyCode: page.get('params').get('currencyCode') });
                        contentModel.set('selectedAccount', account);

                    });
                });


            });
        });


        var errors = {
            INSUFFICIENT_FUNDS: 'Недостаточно средств на счете',
            OPERATION_CLOSED: 'Операция уже завершена',
            WRONG_KEY: 'Неправильный код',
            WRONG_VALUE: 'Введите сумму перевода',
            NO_CONTRACTOR: 'Выберите контрагента'
        };

        function showError(error) {
             contentModel.set({
                error: errors[error] || error,
                stage: 'error'
            });

            setTimeout(function() {
                modalView.enableButtons();
                contentModel.set({
                    stage: 'start'
                });
            }, 3000);
        }

        modalModel.on('action', function(action, cancel) {
            if (action === 'start') {

                cancel();


                contentView.showLoader();
                contentView.disableActions();
                modalView.disableButtons();

                if (!contentModel.get('contractorId')) {
                    return showError('NO_CONTRACTOR');
                }

                if (contentModel.get('value') <= 0) {
                    return showError('WRONG_VALUE');
                }

                page.operationTransferInit(
                    contentModel.get('contractorId'),
                    contentModel.get('selectedAccount').currencyId,
                    contentModel.get('value'),
                    function(error, response) {
                        console.log('operationTransferInit', error, response);

                        if (error) {
                            showError(error);
                        } else {
                            modalView.enableButtons();

                            contentModel.set('privateKey', response.privateKey);

                            contentModel.set({
                                selectedContractor: contractors.findWhere({ id: parseInt(contentModel.get('contractorId'), 10) }),
                                stage: 'confirm'
                            });
                            modalModel.set('buttons', [
                                buttons.confirm,
                                buttons.close
                            ]);
                        }
                    }
                );
            }

            if (action === 'confirm') {
                cancel();

                contentView.showLoader();
                contentView.disableActions();
                modalView.disableButtons();

                page.operationTransferConfirm(
                    contentModel.get('privateKey'),
                    contentModel.get('publicKey'),
                    function(error, response) {
                        console.log('operationTransferInit', error, response);


                        if (error) {
                            contentModel.set({
                                error: errors[error] || error,
                                stage: 'error'
                            });

                            setTimeout(function() {
                                modalView.enableButtons();
                                contentModel.set({
                                    stage: 'confirm'
                                });
                            }, 3000);

                        } else {
                            modalView.enableButtons();

                            contentModel.set('stage', 'success');
                            modalModel.set('buttons', [
                                buttons.close
                            ]);

                            page.get('table').fetch();
                            page.get('summary').fetch();
                            page.get('accounts').fetch();
                        }
                    }
                );
            }

                // contentView.showLoader();
                // contentView.disableActions();
                // modalView.disableButtons();
                // var valid = contentModel.save(null, {
                //     success: function() {
                //         modalView.dispose();
                //     },
                //     error: function(model, resp) {
                //         console.log('ADD ERROR', resp.responseJSON);
                //         contentModel.set('errors', resp.responseJSON.error || { global: 'Ошибка при создании записи' });
                //         contentView.render();
                //         modalView.enableButtons();

                //     }
                // });
                // if (!valid) {
                //     contentModel.set('errors', contentModel.validationError);
                //     contentView.render();
                //     modalView.enableButtons();
                // }

        });
    } // openTransferModal


    var Controller = BaseController.extend({
        show: function(p, route, opts) {
            var pageView;

            // CREATE MODELS
            var params = new Params(p, { parse: true });

            var accounts = new Accounts({ params: params });
            var summary = new Summary({ params: params });
            var table = new Table({ params: params });

            var page = new Page({
                params: params,
                accounts: accounts,
                summary: summary,
                table: table
            });

            function loadData() {
                console.log('loadData');
                if (params.isValid()) {

                    accounts.fetch()
                        .then(function() {
                            utils.changeURL('multi-account#show', { currencyCode: params.get('currencyCode') }, params.urlParams());
                            table.fetch();
                            summary.fetch();
                        });
                }
            }

            params
                .on('change', loadData);

            page.on('operationTransfer', function() {
                openTransferModal(page);
            });


            // CREATE VIEWS
            pageView = new PageView({ model: page });
            this.view = pageView;

            pageView.subview('navbar', new NavbarView({ model: page }));
            pageView.subview('tabs', new TabsView({ model: accounts }));
            pageView.subview('summary', new SummaryView({ model: summary }));
            pageView.subview('table', new TableView({ model: table }));

            loadData();
        }
    });

    return Controller;
});

